import { useState, useRef, useContext } from "react";

import classes from "./LoginForm.module.scss";
import { LockClosedIcon } from "./Icons";
import alertIcon from "../assets/akar-icons_alert.svg";

import ValidUserContext from "../authCheck";
import Modal from "react-modal";

function ResetForm() {
  const validUserContext = useContext(ValidUserContext);

  const passwordInputRef = useRef();
  const passwordConfirmInputRef = useRef();

  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalText, setModalText] = useState("Error");

  function openModal(text) {
    setModalText(text);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const validatePassword = (password) => {
    const passwordPattern =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[+=-_()#@$!%*?&])[A-Za-z\d+=-_#()@$!%*?&]{8,}$/;
    return passwordPattern.test(password);
  };

  const submitHandler = (event) => {
    event.preventDefault();
    if (passwordInputRef.current.value !== passwordConfirmInputRef.current.value) {
      openModal("Passwords do not match");
    } else if (!validatePassword(passwordInputRef.current.value)) {
      openModal(
        "Password needs to be at least 8 characters with one uppercase, one lowercase, one digit and one special character"
      );
    } else {
      validUserContext.apiPwdReset(passwordInputRef.current.value, "");
    }
  };

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(255, 255, 255, 0.20)",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      backgroundColor: "white",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
    },
  };

  return (
    <div className={classes.logincontainer}>
      <form onSubmit={submitHandler} className={classes.form}>
        <div className={classes.loginInstructions}>Set your password</div>
        <div className={classes.loginSubtitle}>
          Choose a new password for your Conference Direct Insights account
        </div>

        <label className={classes.field}>
          <LockClosedIcon className={classes.fieldIcon} />
          <input
            className={classes.input}
            type="password"
            id="user-password"
            name="user-password"
            autoComplete="new-password"
            placeholder="New password"
            ref={passwordInputRef}
            required
          />
        </label>

        <label className={classes.field}>
          <LockClosedIcon className={classes.fieldIcon} />
          <input
            className={classes.input}
            type="password"
            id="user-password-confirm"
            name="user-password-confirm"
            autoComplete="new-password"
            placeholder="Confirm password"
            ref={passwordConfirmInputRef}
            required
          />
        </label>

        <button
          className={classes.loginBtn}
          disabled={validUserContext.isLoggedIn || validUserContext.isLoggingIn}
        >
          {validUserContext.isLoggingIn ? "Saving…" : "Set new password"}
        </button>

        <button
          type="button"
          className={classes.linkBtn}
          onClick={validUserContext.reset}
        >
          Back to sign in
        </button>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Password validation"
        >
          <img className={classes.alerticon} src={alertIcon} alt="" />
          <div className={classes.modaltext}>{modalText}</div>
        </Modal>
      </form>
    </div>
  );
}

export default ResetForm;
